const WEEKLY_DAY_WORKINGS = [
  { name: '週1~2日', value: 1 },
  { name: '週2~3日', value: 2 },
  { name: '週3~4日', value: 3 },
  { name: '週4~5日', value: 4 },
  { name: '週5~6日', value: 5 },
  { name: '週6~7日', value: 6 },
  { name: '週7日', value: 7 },
]

export default WEEKLY_DAY_WORKINGS;
